import ApiConfig from '@api';
import AppConfig from '@app';
import Channel from '../classes/channel';
import Modals from '../types/enums/modals';
import Storage from '@storage';
import User from '../classes/user';
import goToChannel from '../actions/channels/goToChannel';
import { clearModal, setModal } from '../store/slices/modal.slice';
import { popRoute } from '../store/thunks/route.thunk';
import { store } from '../store/store';

const DEFAULT_TIMEOUT = 60 * 1000; // Stage & Prod: 1 minute

const MODAL_TIMEOUT =
  AppConfig.environment === 'dev' || ApiConfig.environment === 'stage'
    ? 3 * 60 * 1000
    : 2 * 60 * 60 * 1000; // Stage: 3 minutes, Prod: 2 hours

const ZAPPER_TIMEOUT =
  AppConfig.environment === 'dev' || ApiConfig.environment === 'stage'
    ? 3 * 60 * 1000
    : 5 * 60 * 1000; // Stage: 3 minutes, Prod: 5 minutes

const DeadmanUtils = {
  default: {
    action: (currentChannel?: Channel, overwrite?: boolean) => {
      const { channels, user } = store.getState();
      const defaultChannel = channels.channelsData?.find(
        (item) => item.code === User.getPlan(user?.planId)?.defaultChannel
      );
      goToChannel({
        channel: defaultChannel || currentChannel,
        overwrite,
      }, true);
    },
    timeout: DEFAULT_TIMEOUT,
  },
  closeZapper: {
    action: () => {
      const { channels, media } = store.getState();

      // Whether the user has activated power saving or not
      const deadmanActive =
        Storage.get('deadmanActive') === '1' || !Storage.get('deadmanActive');

      // Whether the current content permits deadman to trigger
      const deadmanAvailable =
        !media.live || (media.live && channels?.currentChannel?.deadman);

      // Deadman will end content playback if available and is active
      if (deadmanAvailable && deadmanActive) {
        store.dispatch(popRoute());
        store.dispatch(clearModal());
      }
    },
    timeout: ZAPPER_TIMEOUT,
  },
  openModal: {
    action: () => {
      const { channels, media } = store.getState();

      // Whether the user has activated power saving or not
      const deadmanActive =
        Storage.get('deadmanActive') === '1' || !Storage.get('deadmanActive');

      // Whether the current content permits deadman to trigger
      const deadmanAvailable =
        !media.live || (media.live && channels?.currentChannel?.deadman);

      // Modal will open if the content allows it and deadman is active
      if (deadmanAvailable && deadmanActive) {
        store.dispatch(setModal(Modals.DEADMAN_ZAPPER));
      }
    },
    timeout: MODAL_TIMEOUT,
  },
};

export default DeadmanUtils;
